export class ISliderConfig {

    value = -1;
    min = 0;
    max = 0;
    step = 1;
    overMin = false;
    overMax = false;
    unit = '';
    dirty = false;

    isInvalid(): boolean {
        return (this.value === -1) && this.dirty;
    }

    getRoundedMin(): number {
        if (this.min % this.step !== 0) {
            return Math.floor(this.min / this.step) * this.step;
        }
        return this.min;
    }

    getRoundedMax(): number {
        if (this.max % this.step !== 0) {
            return Math.floor(this.max / this.step) * this.step + this.step;
        }
        return this.max;
    }

    getMin(): number {
        if (this.overMin) {
            return 0;
        }
        return this.getRoundedMin();
    }

    getMax(): number {
        return this.getRoundedMax();
    }
}
